export function buildGraph(data) {
  const nodes = [];
  const links = [];

  function traverse(node, parentId = null) {
    nodes.push({
      id: node.id,
      name: node.name,
      category: node.category,
      status: node.status,
      severity: node.severity,
      ip: node.ipAddress,
      location: node.location,
      level: node.level,
    });
    if (parentId) {
      links.push({ source: parentId, target: node.id });
    }
    if (node.children && node.children.length) {
      node.children.forEach((child) => traverse(child, node.id));
    }
  }

  data?.forEach((root) => traverse(root));
  return { nodes, links };
}
